import * as React from 'react';
import { AddToCart } from '@grandvisionhq/carts-v2';
import { useIntl } from '@grandvisionhq/state';

const NonRxProductAddToCartButton = ({ activeSku , offeringSku , bundleLineItemSkus , onSuccess , quantity =1 , caption ,  })=>{
    const { getLabel  } = useIntl();
    let lineItemDraft;
    if (!bundleLineItemSkus || bundleLineItemSkus.length === 0) {
        // Add a Regular product to cart
        const draft = {
            sku: activeSku,
            quantity,
            type: 'regular'
        };
        lineItemDraft = draft;
    } else {
        // Add a Non-Rx Bundle product to cart
        const skus = offeringSku ? [
            offeringSku,
            ...bundleLineItemSkus
        ] : bundleLineItemSkus;
        const draft = {
            sku: activeSku,
            quantity: 1,
            type: 'non-prescription-bundle',
            bundleLineItems: skus.map((sku)=>({
                    sku,
                    quantity: 1
                })
            )
        };
        lineItemDraft = draft;
    }
    return /*#__PURE__*/ React.createElement(AddToCart, {
        caption: caption !== null && caption !== void 0 ? caption : getLabel('products.actions.addToCart'),
        onSuccess: onSuccess,
        lineItemDrafts: [
            lineItemDraft
        ]
    });
};

export { NonRxProductAddToCartButton };
//# sourceMappingURL=NonRxProductAddToCartButton.js.map
